// Complete Drawer Layout Wrapper
// Handles all drawer logic internally - just pass callbacks

import React from 'react';
import Box from '@mui/material/Box';
import ResponsiveDrawer from './ResponsiveDrawer';
import MainContent from './MainContent';
import useDrawer from '../hooks/useDrawer';
import drawerConfig from '../drawerConfig';

/**
 * DrawerLayout - Complete layout with drawer and main content.
 *
 * @param {Object}   props
 * @param {boolean}  props.isAuthenticated  - Whether user is logged in
 * @param {Array}    props.menuItems        - Menu items array
 * @param {Function} props.onMenuClick      - Menu item click handler
 * @param {Function} props.onLogout         - Logout handler
 * @param {boolean}  props.mobileDrawerOpen - Mobile drawer open state (lifted to App)
 * @param {Function} props.onMobileDrawerClose - Close mobile drawer
 * @param {ReactNode} props.children        - Main content to render
 */
export default function DrawerLayout({
  isAuthenticated,
  menuItems,
  onMenuClick,
  onLogout,
  mobileDrawerOpen,
  onMobileDrawerClose,
  children,
}) {
  const {
    open,
    showScrollbar,
    handleDrawer,
    handleMouseMove,
    handleMouseLeave,
  } = useDrawer();

  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      {/* Drawer - only show when authenticated */}
      {isAuthenticated && drawerConfig.enabled && (
        <ResponsiveDrawer
          open={open}
          showScrollbar={showScrollbar}
          onToggle={() => handleDrawer(!open)}
          mobileOpen={mobileDrawerOpen}
          onMobileClose={onMobileDrawerClose}
          menuItems={menuItems}
          onMenuClick={onMenuClick}
          onLogout={onLogout}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        />
      )}

      {/* Main Content */}
      <MainContent open={!!open} hasUser={isAuthenticated}>
        {children}
      </MainContent>
    </Box>
  );
}
